import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const variants = {
  error: 'bg-destructive/20 border-destructive/50 text-destructive',
  success: 'bg-success/20 border-success/50 text-success',
  warning: 'bg-warning/20 border-warning/50 text-warning',
  info: 'bg-info/20 border-info/50 text-info',
} as const;

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof variants;
}

export function Alert({ className, variant = 'info', ...props }: AlertProps) {
  return <div className={cn('p-4 rounded-lg border text-sm', variants[variant], className)} {...props} />;
}
